module.exports = __webpack_public_path__ + "static/media/country_au.98d0c422.webp";